import { TRACKING_SCREEN_MAPPING } from '../constants';

export const getTrackingScreenName = (
  tenant: string,
  isMobile: boolean,
  pathname: string,
) => {
  const platform = isMobile ? 'mobile' : 'desktop';
  const tenantPrefix = `/${tenant}/${platform}`;
  const tenantPrefixDefault = `/default/${platform}`;
  let actualRoute;
  if (pathname.includes(tenantPrefix))
    actualRoute = pathname.replace(tenantPrefix, '');
  else actualRoute = pathname.replace(tenantPrefixDefault, '');
  return TRACKING_SCREEN_MAPPING[actualRoute];
};
